export default __webpack_public_path__ + "static/media/home.daf09a6a.png";